document.addEventListener("DOMContentLoaded", () => {
  const isLoyaltyLogin = (root) => Boolean(root?.querySelector?.("[data-loyalty-login='true']"));
  const isGiftLocked = (card) => card?.dataset.giftLocked === "true" || card?.dataset.thresholdLocked === "true";
  const hideAuxiliaryCtasForGiftLock = (card) => {
    const waitlistContainer = card?.querySelector(".waitlist-container");
    const outOfStockContainer = card?.querySelector(".back-in-stock-container");

    if (waitlistContainer) {
      waitlistContainer.style.display = "none";
    }
    if (outOfStockContainer) {
      outOfStockContainer.innerHTML = "";
      outOfStockContainer.style.display = "none";
    }
  };
  const resolveWaitlistEnabled = (variant) => {
    if (!variant) return false;
    const effective = variant.effectiveWaitlist;
    const fallback = variant.enableWaitlist;
    const value = effective !== undefined && effective !== null ? effective : fallback;
    return value === true || value === "true";
  };
  const enforceGiftLock = (card) => {
    if (!card || !isGiftLocked(card)) return;

    hideAuxiliaryCtasForGiftLock(card);

    card.querySelectorAll(".product-form__submit").forEach((button) => {
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
      button.dataset.giftLock = "true";
      button.dataset.thresholdLock = "true";
    });

    const variantInput = card.querySelector(".product-variant-id");
    if (variantInput) {
      variantInput.disabled = true;
    }
  };

  const updateProductPrice = (card, price, compareAtPrice, savePrice) => {
    const container = card.querySelector(".price-section-data");
    const priceSale = card.querySelector(".price__sale");
    const priceRegular = card.querySelector(".price__regular");
    const comparePriceEl = card.querySelector(".product-compare-at-price");
    const savePriceEl = card.querySelector(".product-save-price");

    card.querySelectorAll(".product-price").forEach((el) => {
      el.innerHTML = price;
    });

    const isOnSale = compareAtPrice && compareAtPrice !== price && compareAtPrice !== "$0.00";

    container.classList.toggle("price--on-sale", isOnSale);
    priceSale.style.display = isOnSale ? "flex" : "none";
    priceRegular.style.display = isOnSale ? "none" : "flex";

    if (isOnSale) {
      comparePriceEl.innerHTML = compareAtPrice;
      savePriceEl.innerHTML = savePrice;
    }
  };

  const updateUndertoneValue = (card, undertone, labelText) => {
    const formatted = undertone ? undertone.charAt(0).toUpperCase() + undertone.slice(1) : "";

    card.querySelectorAll(".custom-select").forEach((select) => {
      select.querySelector(".option-value").textContent = labelText;

      const undertoneEl = select.querySelector(".variant-undertone");
      if (undertoneEl) {
        undertoneEl.textContent = formatted ? window.variantStrings.undertoneLabel.replace("[value]", formatted) : "";
      }
    });
  };

  const updateShortDescription = (card, description, size) => {
    const shortDescriptionEl = card.querySelector(".featured-card_product-description");
    if (!shortDescriptionEl) return;

    const contentMode = shortDescriptionEl.dataset.contentMode || "description";
    if (contentMode === "hidden") {
      shortDescriptionEl.classList.add("hide");
      return;
    }

    if (contentMode === "static-label") {
      shortDescriptionEl.classList.toggle("hide", !shortDescriptionEl.textContent.trim());
      return;
    }

    if (description || size) {
      let html = "";
      if (description) {
        html += `<span class="inner-description">${description}</span>`;
      }
      if (size) {
        html += ` <span class="hide-on-mobile">●</span>`;
        html += ` <span>${size}</span>`;
      }
      shortDescriptionEl.innerHTML = html;
      shortDescriptionEl.classList.remove("hide");
    } else {
      shortDescriptionEl.classList.add("hide");
    }
  };

  const updateSuggestedItemOutOfStockDisplay = (card, variant, parsedData) => {
    const outOfStockContainer = card.querySelector(".back-in-stock-container");
    const productFormButtons = card.querySelector(".product-form__buttons");

    if (isGiftLocked(card)) {
      hideAuxiliaryCtasForGiftLock(card);
      return;
    }

    if (!variant) {
      if (outOfStockContainer) outOfStockContainer.style.display = "none";
      if (productFormButtons) productFormButtons.classList.remove("hide");
      return;
    }
    if (isLoyaltyLogin(card)) {
      return;
    }

    const variantOnlineValue = variant.variantOnline;
    const backInStockValue = variant.backInStock;
    const isWaitlistEnabled = resolveWaitlistEnabled(variant);

    // Reset states initially to ensure proper visibility changes
    if (outOfStockContainer) outOfStockContainer.innerHTML = ""; // Clear existing messages
    if (outOfStockContainer) outOfStockContainer.style.display = "none";
    if (productFormButtons) productFormButtons.classList.remove("hide");

    if (variantOnlineValue === "false") {
      if (outOfStockContainer) {
        outOfStockContainer.innerHTML = `
          <button type="button" class="back-in-stock-btn" disabled>
            ${window.variantStrings.unavailable}
          </button>
        `;
        outOfStockContainer.style.display = "block";
      }
      if (productFormButtons) productFormButtons.classList.add("hide");
      return;
    }

    // Check if waitlist should be shown first (takes priority over out-of-stock)
    const shouldShowWaitlist =
      isWaitlistEnabled && (variant.available || (!variant.available && backInStockValue === "true"));

    // If waitlist should be shown, don't show out-of-stock
    if (shouldShowWaitlist) {
      outOfStockContainer.innerHTML = "";
    }

    const shouldShowOutOfStock = !variant.available && backInStockValue === "true" && !isWaitlistEnabled;
    const shouldShowBackInStock = !variant.available && backInStockValue !== "true";
    const productHandle = parsedData.handle || card.dataset.handle || variant.handle;

    if (shouldShowOutOfStock) {
      if (outOfStockContainer) {
        outOfStockContainer.innerHTML = `
          <button
            type="button"
            class="button button--full-width out-of-stock-btn">
            ${window.getStockStatusLabel?.(productHandle) || window.variantStrings?.soldOut}
          </button>
        `;
        outOfStockContainer.style.display = "block";
      }
      if (productFormButtons) productFormButtons.classList.add("hide");
    } else if (shouldShowBackInStock) {
      if (outOfStockContainer) {
        const root = window.Shopify?.routes?.root || "/";
        const productUrl = `${root}products/${productHandle || ""}`;
        outOfStockContainer.innerHTML = `
          <div class="back-in-stock-form">
            <a href="${productUrl}" class="button button button--full-width button--primary notify-me-btn">Notify Me</a>
          </div>
        `;
        outOfStockContainer.style.display = "block";
      }
      if (productFormButtons) productFormButtons.classList.add("hide");
    } else {
      if (productFormButtons) productFormButtons.classList.remove("hide");
      if (outOfStockContainer) outOfStockContainer.innerHTML = "";
      if (outOfStockContainer) outOfStockContainer.style.display = "none";
    }

    // If waitlist should be shown, make sure buy buttons are hidden
    if (shouldShowWaitlist) {
      productFormButtons.classList.add("hide");
    }
  };

  const updateSuggestedItemWaitlistDisplay = (card, variant) => {
    const productFormButtons = card.querySelector(".product-form__buttons");
    const waitlistContainer = card.querySelector(".waitlist-container");

    if (isGiftLocked(card)) {
      hideAuxiliaryCtasForGiftLock(card);
      return;
    }

    if (!variant || isLoyaltyLogin(card)) {
      return;
    }

    const isWaitlistEnabled = resolveWaitlistEnabled(variant);
    const backInStockValue = variant.backInStock;

    // New waitlist logic: 2 cases
    // 1. Variant available AND waitlist = true
    // 2. Not available AND waitlist = true AND back_in_stock_disabled = true
    const shouldShowWaitlist =
      isWaitlistEnabled && (variant.available || (!variant.available && backInStockValue === "true"));

    if (shouldShowWaitlist) {
      // Hide buy buttons when waitlist is enabled
      if (productFormButtons) {
        productFormButtons.classList.add("hide");
      }

      // Show waitlist form
      if (waitlistContainer) {
        waitlistContainer.style.display = "block";
      }
    } else {
      // Show buy buttons when waitlist is disabled
      if (productFormButtons) {
        productFormButtons.classList.remove("hide");
      }

      // Hide waitlist form
      if (waitlistContainer) {
        waitlistContainer.style.display = "none";
      }
    }
  };

  document.body.addEventListener("click", (event) => {
    const option = event.target.closest(".custom-option");
    if (!option) return;

    const card = option.closest(".suggested-items__product-card__wrapper");
    if (!card) return;

    const productDataJSON = card.querySelector("[suggested-items-data-selected-variant-meta]")?.innerHTML;
    if (!productDataJSON) return;

    const parsedData = JSON.parse(productDataJSON);

    const is_bundled = card.className.includes("bundled-suggested-item");
    let variant;

    if (is_bundled) {
      let selected_option_name;
      if (option.className.includes("mobile-bundle-option")) {
        selected_option_name = Array.from(card.querySelectorAll(".selected-bundle-option.mobile-bundle-option"));
      } else {
        selected_option_name = Array.from(card.querySelectorAll(".selected-bundle-option.desktop-bundle-option"));
      }
      const rawPosition = option.dataset.position;
      const position = parseInt(rawPosition);
      const option_item = option.dataset.value;
      if (!isNaN(position) && selected_option_name[position]) {
        selected_option_name[position].value = option_item;
      }
      const filtered_options = Array.from(selected_option_name)
        .filter((option) => !option.classList.contains("single-product"))
        .map((option) => option.value.trim());

      variant = parsedData.variants.find((inner_variant) => {
        const inner_options = [...inner_variant.options].map((opt) => opt.trim());
        return (
          inner_options.length === filtered_options.length &&
          inner_options.every((option, index) => option === filtered_options[index])
        );
      });
    } else {
      variant = parsedData.variants?.find((item) => item.id == option.dataset.id);
      if (!variant) return;
    }

    const swatchIdInput = card.querySelector(".product-variant-id");
    if (swatchIdInput) swatchIdInput.value = variant.id;

    if (!is_bundled) {
      const image = card.querySelector(".suggested-items-image");
      if (image && variant.image_url?.[0]) {
        image.src = variant.image_url[0];
      }
    }

    updateShortDescription(card, variant.shortDescription, variant.size);
    if (!is_bundled) {
      updateUndertoneValue(card, variant.underTone, option.textContent.trim());
    }
    updateProductPrice(card, variant.price, variant.compare_at_price, variant.save_price);
    updateSuggestedItemWaitlistDisplay(card, variant);
    updateSuggestedItemOutOfStockDisplay(card, variant, parsedData);
    enforceGiftLock(card);
  });

  // Initial call for each suggested item card on page load
  document.querySelectorAll(".suggested-items__product-card__wrapper").forEach((card) => {
    const productDataJSON = card.querySelector("[suggested-items-data-selected-variant-meta]")?.innerHTML;
    if (productDataJSON) {
    const parsedData = JSON.parse(productDataJSON);
    const default_selected_variant = parsedData.default_selected_variant;
    if (default_selected_variant) {
      updateSuggestedItemWaitlistDisplay(card, default_selected_variant);
      updateSuggestedItemOutOfStockDisplay(card, default_selected_variant, parsedData);
    }
  }
    enforceGiftLock(card);
  });
});
